var _path, _rect, _path2, _path3, _circle, _rect2, _rect3, _rect4, _path4, _circle2, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUxUi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 256,
    height: 256,
    viewBox: "0 0 128 128",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e8",
    d: "M42.4,9.5H89.6a8.035,8.035,0,0,1,8.035,8.035v96.929A8.036,8.036,0,0,1,89.6,122.5H42.4a8.036,8.036,0,0,1-8.036-8.036V17.536A8.036,8.036,0,0,1,42.4,9.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61.275,
    height: 111,
    x: 31.362,
    y: 6.5,
    fill: "#6dc9f7",
    rx: 7.035,
    ry: 7.035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0089ef",
    d: "M48.417,107.34H41.583a2.417,2.417,0,0,0,0,4.833h6.834a2.417,2.417,0,0,0,0-4.833Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0089ef",
    d: "M82.417,107.34H75.583a2.417,2.417,0,0,0,0,4.833h6.834a2.417,2.417,0,0,0,0-4.833Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 109.756,
    r: 4.5,
    fill: "#0089ef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 61.275,
    height: 84.657,
    x: 31.362,
    y: 16.929,
    fill: "#d4fbff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 61.275,
    height: 3,
    x: 31.362,
    y: 98.586,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 19.128,
    height: 2.269,
    x: 52.436,
    y: 10.686,
    fill: "#0089ef",
    rx: 1.026,
    ry: 1.026
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0089ef",
    d: "M76.1,10.575a1.246,1.246,0,1,0,1.245,1.246A1.245,1.245,0,0,0,76.1,10.575Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.44,
    cy: 60,
    r: 22.94,
    fill: "#fa759e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a2c60",
    d: "M92.638,30.9a1,1,0,0,0-1,1v8.08a1,1,0,0,0,2,0V31.9A1,1,0,0,0,92.638,30.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a2c60",
    d: "M85.6,5.5H38.4a8.045,8.045,0,0,0-8.036,8.036v96.928A8.045,8.045,0,0,0,38.4,118.5H85.6a8.046,8.046,0,0,0,8.036-8.036V44.818a1,1,0,0,0-2,0v55.768H32.362V17.929H91.638v9.139a1,1,0,0,0,2,0V13.536A8.046,8.046,0,0,0,85.6,5.5Zm6.036,97.086v7.878A6.043,6.043,0,0,1,85.6,116.5H38.4a6.043,6.043,0,0,1-6.036-6.036v-7.878ZM32.362,15.929V13.536A6.043,6.043,0,0,1,38.4,7.5H85.6a6.043,6.043,0,0,1,6.036,6.036v2.393Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a2c60",
    d: "M38.5,60A23.941,23.941,0,1,0,62.44,36.06,23.967,23.967,0,0,0,38.5,60Zm45.881,0A21.941,21.941,0,1,1,62.44,38.06,21.965,21.965,0,0,1,84.381,60Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.759,66.672A6.955,6.955,0,0,1,47,61.536V53.07a1.494,1.494,0,0,1,.4-1.091,1.625,1.625,0,0,1,2.158,0,1.5,1.5,0,0,1,.4,1.091V61.7a4.6,4.6,0,0,0,1.008,3.225,3.827,3.827,0,0,0,2.955,1.091,3.773,3.773,0,0,0,2.933-1.1A4.606,4.606,0,0,0,57.858,61.7V53.07a1.5,1.5,0,0,1,.4-1.091,1.625,1.625,0,0,1,2.158,0,1.5,1.5,0,0,1,.4,1.091v8.466a6.967,6.967,0,0,1-1.759,5.125,6.931,6.931,0,0,1-5.136,1.77A6.99,6.99,0,0,1,48.759,66.672Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.348,66.954a1.338,1.338,0,0,1-.433.985,1.393,1.393,0,0,1-1,.422,1.334,1.334,0,0,1-1.033-.516l-4.76-5.91-4.784,5.91a1.292,1.292,0,0,1-1.009.493,1.408,1.408,0,0,1-1-.411,1.3,1.3,0,0,1-.434-.973,1.373,1.373,0,0,1,.351-.891l5.114-6.239-4.9-5.981a1.259,1.259,0,0,1-.352-.891,1.308,1.308,0,0,1,.423-.973,1.37,1.37,0,0,1,.984-.41,1.332,1.332,0,0,1,1.032.516l4.574,5.652L74.7,52.085a1.265,1.265,0,0,1,1.009-.516,1.411,1.411,0,0,1,1,.41,1.294,1.294,0,0,1,.434.973,1.254,1.254,0,0,1-.352.891l-4.9,5.981,5.09,6.239A1.388,1.388,0,0,1,77.348,66.954Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxUi);
export default __webpack_public_path__ + "static/media/ux-ui.79fe41829e306b24f21ff9d3b8d2c8a2.svg";
export { ForwardRef as ReactComponent };